import React, {useState} from 'react';
import 'react-tabs/style/react-tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {CommunicationStatus } from './CommunicationStatus';
import {RegisteredDefaultDebtorRecords } from './RegisteredDefaultDebtorRecords';
import {DeRegisteredDefaultDebtorRecords } from './DeRegisteredDefaultDebtorRecords';
import { useAuthContext } from 'components/special/oAuthProvider';


export const DefaultDebtorRegistryOverview = ()  => { 
    const [mainTabSelected, setMainTabSelected] = useState(0); 
    const { user } = useAuthContext();

    console.log("user", user);

  return (
    <div>
      <div className="grid tight collapse480">
          <div className="col s6of12">
              <h1 className="text-red text-32">Vanskilaskrá</h1>
              <br/>
              Kt umboðsmanns : {user.s_regno}
          </div>
      </div>     

      <div className="grid">            
            <div className="col s1of1">            
            <Tabs selectedIndex={mainTabSelected} onSelect={ (index) => setMainTabSelected(index) }>
                <TabList>
                <Tab>Samskiptaskrá</Tab>                
                <Tab>Færslur á vanskilaskrá</Tab>                
                <Tab>Færslur afkráðar af vanskilaskrá</Tab>                
                </TabList>                  
                <TabPanel><CommunicationStatus/></TabPanel>                
                <TabPanel><RegisteredDefaultDebtorRecords/></TabPanel>                
                <TabPanel><DeRegisteredDefaultDebtorRecords/></TabPanel>                
            </Tabs>
           </div>
        </div>     

  </div>
  );
};
